import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as vehicleActions from '../actions/vehicleActions';
import LoadingOverlay from '../components/LoadingOverlay';
import moment from 'moment';
import Reg from '../components/Reg';
import Select from 'react-select';



class AddVehicleForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalTimeChange: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle(property) {
        let newState = {};
        newState[property] = !this.state[property];
        this.setState(newState);
    }

    selectVehicle = (values) => {
        this.setState({ selectedOption: values });

        if (values) {
            this.props.vehicleActions.addVehicle(values);
        } else {
            if (this.props.vehicles.list.length > 0) {
                this.props.vehicleActions.addVehicle(this.props.vehicles.list[0]);
            } else {
                const vehicle = { id: null,vehicleReg: null,colour: null,nickname: null,make: null,model: null,vehicleDetail: null,isDefault: null, activeServicesCount: null }
                this.props.vehicleActions.addVehicle(vehicle);
            }
        }
    }
    handleChange = (selectedOption) => {
        console.log('Selected option: ', selectedOption);
        this.selectVehicle(selectedOption.value);
    };

    createSelectOptions(vehicles) {
        return vehicles.map(vehicle => ({
            value: vehicle,
            label: (this.vehicleLabel (vehicle))
        }));
    } 

    vehicleLabel (vehicle) {
        return (
            <span>
                {vehicle.nickname ? (
                    <strong className="pr-2">
                        {vehicle.nickname}
                    </strong>
                ) : null}
                <span className="mono">
                    <Reg reg={vehicle.vehicleReg} />
                </span>&nbsp;
                {` ${vehicle.make ? (vehicle.make.charAt(0).toUpperCase() + vehicle.make.slice(1).toLowerCase()) : ''} ${vehicle.model ? (vehicle.model.charAt(0).toUpperCase() + vehicle.model.slice(1).toLowerCase()) : ''} ${vehicle.color ? (vehicle.color.charAt(0).toUpperCase() + vehicle.color.slice(1).toLowerCase()) : ''}`.trim()}
            </span>
        );
    }
    

    // function returns true if the vehicleReg is already in the list
    isVehicleNotInList(vehicleReg) {
        console.log('vehicleReg, ', vehicleReg);
        if (!vehicleReg) return false;
        return !this.props.vehicles.list.some(vehicle => vehicle.vehicleReg === vehicleReg);
    }
    

    render() {
        let { vehicleData } = this.props.accountDetails;
        let selectedOption;
        const { addVehicle } = this.props;
        const options = this.createSelectOptions(this.props.vehicles.list);
        const vehicleLabel = this.vehicleLabel;


        return (
            <div className="row">
                <form>
                    <div className="account-card">
                        <div className="row header">
                            <div className="col-12 col-md-12">
                                <label>Vehicle Details</label>
                            </div>
                            <hr />
                        </div>

                        {this.props.vehicles.list.length > 0 ? (
                            <div className="row">
                                <div className={"col-8 t z-10 "}>
                                    <label for="react-select-2-input" className="inline-block">
                                        Your Vehicles:
                                    </label>
                                    {this.props.vehicles.list.length > 5 ? (
                                        <Select
                                            value={selectedOption}
                                            onChange={this.handleChange} 
                                            options={options}
                                            className={"t " + (this.isVehicleNotInList(this.props.accountDetails.vehiclePlate) ? "o-50__1" : "o-100__1")}
                                        />
                                    ) : (
                                        <div>
                                            <ul className="list-group">
                                            {
                                                this.props.vehicles.list.map(vehicle => (
                                                    <label 
                                                        key={vehicle.vehicleReg}
                                                        className="inp-radio"
                                                        htmlFor={vehicle.vehicleReg}>
                                                            
                                                        <input 
                                                            type="radio" 
                                                            name="vehicle" 
                                                            id={vehicle.vehicleReg} 
                                                            value={vehicle.vehicleReg} 
                                                            onChange={() => this.selectVehicle(vehicle)}
                                                            checked={vehicle.vehicleReg === this.props.accountDetails.vehiclePlate}
                                                            aria-invalid="false" 
                                                            style={{}} 
                                                        />
                                                        <span className="input">&nbsp;</span>
                                                        <span>
                                                            <span className={
                                                                "t d-inline-block " + (
                                                                    vehicle.vehicleReg === this.props.accountDetails.vehiclePlate ? "tX-5 " : "tX-0 ") + (
                                                                        (this.props.accountDetails.vehiclePlate && vehicle.vehicleReg != this.props.accountDetails.vehiclePlate) ? "o-50__1" : null
                                                                        )
                                                                }>
                                                                {vehicleLabel (vehicle)}
                                                            </span>
                                                        </span>
                                                    </label>
                                                ))
                                            }
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                <div className={"col-4 text-right d-flex " + (this.props.vehicles.list.length > 5 ? "align-items-start" : "align-items-end")}>
                                    <button 
                                        type="button" 
                                        className="btn btn-primary btn-sm w-100 mb-3" 
                                        onClick={() => addVehicle()}>
                                        Select other vehicle
                                    </button>
                                </div>
                            </div>
                        ) : null}

                        {!this.props.accountDetails.vehicleData && this.props.vehicles.list.length === 0 ? (
                            <div className="row text-center">
                                <div className="col-12 col-md-12">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => addVehicle()}
                                        type="button"
                                    >
                                        {this.props.vehicles.list.length > 0 ? (
                                            <span>Select Other Vehicle</span>
                                        ) : (
                                            <span>Select Vehicle</span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                {this.props.vehicles.list.length === 0 ? (
                                    <div className="row vehicle-details">
                                        <div className="col-md-9">
                                            <div className="car-info">
                                                <span className="license-plate">
                                                    <Reg reg={this.props.accountDetails.vehiclePlate} />
                                                </span>
                                                {`${this.props.accountDetails.vehicleData && this.props.accountDetails.vehicleData.color ? this.props.accountDetails.vehicleData.color : ''} ${this.props.accountDetails.vehicleData ? this.props.accountDetails.vehicleData.make : ''} ${this.props.accountDetails.vehicleData ? this.props.accountDetails.vehicleData.model : ''}`}
                                            </div>
                                        </div>
                                        <div className="col-md-3 text-right">
                                            <button 
                                                type="button" 
                                                className="btn btn-link btn-sm" 
                                                onClick={() => addVehicle()}>
                                                Select other vehicle
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        )}

                        { this.isVehicleNotInList(this.props.accountDetails.vehiclePlate) && this.props.vehicles.list.length != 0 ? (
                            <div className="row vehicle-details">
                                <div className="col-md-12">
                                    <div className="input_out input_out_inputButton">
                                        <input className="inp-cbx" 
                                            id="customVehiclePicked" 
                                            type="checkbox" 
                                            name="customVehiclePicked"
                                            checked={true}
                                            value={true}
                                            />

                                        <label className="cbx m-0" 
                                            htmlFor="customVehiclePicked" 
                                            onClick={() => this.selectVehicle(null)}>
                                            <span>
                                                <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                    <polyline points="1.5 6 4.5 9 10.5 1"/>
                                                </svg>
                                            </span>
                                            <span className="cbx-copy">
                                                {vehicleLabel (this.props.accountDetails.vehicleData)}
                                            </span>
                                        </label> 
                                    </div>
                                </div>
                            </div>
                        ) : null }
                    </div>
                </form>
            </div>
        );
    }
}

AddVehicleForm.propTypes = {
    isLoading: PropTypes.bool,
    accountDetails: PropTypes.object,
    addVehicle: PropTypes.func,
    vehicles: PropTypes.array,
};

function mapStateToProps(state) {
    return {
        accountDetails: state.accountDetails,
        vehicleActions: state.vehicleActions,
        vehicles: state.vehicles,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        vehicleActions: bindActionCreators(vehicleActions, dispatch)
    };
}



export default connect(
    mapStateToProps,
    mapDispatchToProps
    )(AddVehicleForm);


// WEBPACK FOOTER //
// ./src/forms/AddVehicleForm.jsx